import { createAsyncThunk, createSelector, createSlice } from '@reduxjs/toolkit'
import { SYSTEM_SETTINGS } from '../../Constants/ApiDefinations'
import mainApiService from '../../Services'

interface SystemSettingsState {
  maintenanceMode: boolean | null
}

const initialState: SystemSettingsState = {
  maintenanceMode: null,
}

const systemSettingsSlice = createSlice({
  name: 'systemSettings',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch maintenance status
      .addCase(fetchMaintenanceStatus.fulfilled, (state, action) => {
        if (action.payload?.data?.settingValue !== undefined) {
          state.maintenanceMode = action.payload.data.settingValue
        }
      })
      // Update maintenance status
      .addCase(updateMaintenanceStatus.fulfilled, (state, action) => {
        state.maintenanceMode = action.payload
      })
  },
})

export const fetchMaintenanceStatus = createAsyncThunk(
  'systemSettings/fetchMaintenanceStatus',
  async () => {
    const apiConfig = SYSTEM_SETTINGS.GET_STATUS()
    const response: any = await mainApiService(apiConfig)
    return response
  },
)

export const updateMaintenanceStatus = createAsyncThunk(
  'systemSettings/updateMaintenanceStatus',
  async (settingValue: boolean) => {
    const apiConfig = SYSTEM_SETTINGS.UPDATE_STATUS({
      settingId: 'MAINTENANCE_MODE',
      settingValue,
    })
    await mainApiService(apiConfig)
    return settingValue
  },
)

const systemSettingsSelector = (state: { systemSettings: SystemSettingsState }) =>
  state.systemSettings

export const selectMaintenanceMode = createSelector(
  systemSettingsSelector,
  (state) => state.maintenanceMode,
)

export default systemSettingsSlice
